import React from 'react';
import { Modal } from 'react-bootstrap';
import styles from './EmployeeDeleteModal.css';

const EmployeeDeleteModal = ({ show, onCancel, onDelete, employee }) => {
  return (
    <Modal
      show={show}
      onHide={() => {}}
      dialogClassName={`modal-dialog ${styles.dialog}`}
    >
      <Modal.Header bsClass={`modal-header ${styles.header}`}>
        <button
          onClick={onCancel}
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <Modal.Title className={styles.title}>Delete Employee</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.dialogBody}>
        Deleting an employee will erase all of their personal information. Are
        you sure you want to delete{' '}
        <b>{`${employee.first_name} ${employee.last_name}`}</b>?
      </Modal.Body>
      <Modal.Footer>
        <span className="pull-right">
          <button onClick={onCancel} className="btn btn-default">
            Cancel
          </button>
          <button onClick={onDelete} className="btn btn-danger">
            Delete Employee
          </button>
        </span>
      </Modal.Footer>
    </Modal>
  );
};

export default EmployeeDeleteModal;
